export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inspecciones de calidad"])},
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de reportes"])},
          "filter_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplicar filtros"])},
          "download_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descargar"])},
          "not_found_registers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No se encontró registros de inspecciones de calidad"])}
        }
      },
      "en": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quality inspections"])},
          "filter_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter"])},
          "download_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Download"])},
          "not_found_registers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No se encontró registros de inspeccioens de calidad"])}
        }
      }
    }
  })
}